import React from 'react';
import Masonry from 'react-masonry-component';

import Item from './Item';

class Screen extends React.Component {
  renderItems = (users) => {
    return users.map(
      // TODO: Wft.. sometimes _id, sometimes .id ... figure out what's going on
      (user) => user && <Item key={user._id} user={user} />
    );
  };

  render() {
    const { users } = this.props;

    if (!users) {
      return null;
    }

    return (
      <Masonry className="o-layout o-layout--large">
        {this.renderItems(users)}
      </Masonry>
    );
  }
}

export default Screen;



// WEBPACK FOOTER //
// ./src/user/users/List.js